<template>
  <div class="introduction">
    <div class="top_b">
      <div class="container in_nav">
        <div class="row">
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/introduction">公司简介</router-link>
          </div>
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/hope">愿景和价值观</router-link>
          </div>
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/honor">荣誉资质</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="position_r">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="row cla">
                <div class="col-xs-4 swiper_text">

                  愿景：秉承为万物互联、应用智能贡献技术力量。<br>
                  使命：为客户的数据安全连接和应用智能提供技术保障为使命。<br>
                  核心价值观：合作、分享、诚信、担当。<br>
                </div>
                <div class="col-xs-4">
                  <img src="../../assets/Vision_03.jpg" alt="">
                </div>
                <div class="col-xs-4">
                  <img src="../../assets/Vision_04.jpg" alt="">
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="row cla">
                <div class="col-xs-4 swiper_text">
                  我们是一群来自四面八方，有着共同理想并热爱生活的年轻人。<br>
                  我们的团队是一个大家庭, 我们胜则举杯相庆，败则拼死相救。我们坚信，我们的未来我们自己掌握！
                </div>
                <div class="col-xs-4">
                  <img src="../../assets/Vision_01.jpg" alt="">
                </div>
                <div class="col-xs-4">
                  <img src="../../assets/Vision_02.jpg" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
      <div class="row text_img">
        <div class="col-md-5">
          <p>
            我们可为优秀的人才提供：
          </p>
          <aside>
            1、有竞争力的薪酬。<br>
            2、快速发展和提升的平台和空间。<br>
            3、针对优秀毕业人才的奖励计划。<br>
            4、参与国家重点项目的实践机会。<br>
            5、每年公司内、外部培训机会。<br>
            6、行业内资深导师的亲自指导。<br>
            7、年度体检及旅游。
          </aside>
        </div>
        <div class="col-md-7">
          <img src="../../assets/Vision_photo01.png" style="width: 100%" alt="">
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import Footer from '../../components/Footer'
  import Swiper from 'swiper'

  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    mounted() {
      new Swiper('.swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 20,
        // initialSlide: index,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
      });
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  img {
    height: 100%;
  }

  .introduction {

  }
  .cla>div {
    height: 300px;
    position: relative;
    /*padding: 25px 0px;*/
    overflow: scroll;
  }
  .top_b {
    height: 350px;
    background: url("../../assets/Introduction_banner.png") no-repeat center center;
    background-size: cover;
    position: relative;
    margin-bottom: 100px;
  }

  .in_nav {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -30px;
    background: #fff;
    box-shadow: 1px 2px 20px rgba(0, 0, 0, .3);
    padding: 0px;
  }

  .in_nav a {
    padding: 20px 20px;
    display: block;
    font-size: 20px;
    color: #333;
  }

  .i_active {
    color: #fff !important;
    font-size: 20px;
    background: #ff9900;
  }

  .swiper-container {
    width: 100%;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    padding: 20px 0px;
    margin-bottom: 60px;
  }

  .swiper-slide {
    font-size: 18px;
    background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    /*width: 34%;*/
    height: 300px;
  }

  .text_img {
    margin-bottom: 60px;
  }

  .text_img p {
    font-size: 2.8rem;
    color: #333;
    margin-bottom: 20px;
    font-size: 18px;
  }

  .text_img aside {
    font-size: 2.4rem;
    color: #666;
    line-height: 36px;
    font-size: 18px;
  }
  img {
    width: 100%;
  }

  @media (max-width: 768px) {
    .in_nav {
      bottom: -105px;
    }

    .top_b {
      margin-bottom: 150px;
    }

  }
  .swiper_text {
    line-height: 29px;
    width: 30%;
    padding-right: 10px;
    margin-right: 5px !important;
    border-right: 1px solid #ccc;
    font-size: 18px;
    display: flex;
    align-items: center;        /* 垂直居中 */
    justify-content: center;    /* 水平居中 */

  }
  @media (min-width: 992px) {




  }
</style>
